import * as React from 'react';

import { throttle } from 'throttle-debounce';

import { ROOT_ELEMENT_ID, TOP_MENU_ID, LEFT_MENU_ID } from '@constants';

import { isMobileScreen } from '@base/utils';

interface IUsePreventScroll {
	isDisableScroll: boolean;
	isDOMReady: boolean;
}

const PREVENT_SCROLL_TIMEOUT_MS = 1000;

export function usePreventScroll({ isDisableScroll, isDOMReady }: IUsePreventScroll) {
	if (!IS_SSR) {
		const disableScroll = () => {
			try {
				const topMenuHeight = (document.getElementById(TOP_MENU_ID) as HTMLDivElement)?.offsetHeight;
				const leftMenuHeight = (document.getElementById(LEFT_MENU_ID) as HTMLDivElement)?.offsetHeight;
				const bodyHeight = document.body.offsetHeight;
				const newRootElHeight = Math.min(bodyHeight, topMenuHeight + leftMenuHeight);
				const rootEl = document.getElementById(ROOT_ELEMENT_ID);

				// eslint-disable-next-line no-console
				console.info('[menu fix] on', newRootElHeight, bodyHeight, topMenuHeight, leftMenuHeight, rootEl, isDisableScroll, isDOMReady);

				if (rootEl) {
					rootEl.style.height = `${newRootElHeight}px`;
					rootEl.style.overflow = 'hidden';
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error('[menu fix] error', error);
			}
		};

		const enableScroll = () => {
			const rootEl = document.getElementById(ROOT_ELEMENT_ID);

			// eslint-disable-next-line no-console
			console.info('[menu fix] off');

			if (rootEl) {
				rootEl.style.height = '';
				rootEl.style.overflow = '';
			}
		};

		const onResize = throttle(1000, () =>
			!isMobileScreen() && enableScroll());

		React.useEffect(() => {
			setTimeout(() =>
				isDisableScroll
					? disableScroll()
					: enableScroll(), isDOMReady ? 0 : PREVENT_SCROLL_TIMEOUT_MS);
		}, [isDisableScroll, isDOMReady, !IS_SSR && document]);

		React.useEffect(() => {
			window.addEventListener('resize', onResize);

			return () => window.removeEventListener('resize', onResize);
		}, []);
	}
}
